import React from 'react';

// `className` (optional) lets a stylesheet reach the card, e.g. the comment list's focus ring (ticket 21)
const CustomCard = (props) => {
  return (
    <div className={props.className} style={{background: "white",borderRadius:"10px",overflow: "hidden",display: "flex",flexDirection: "column",fontSize: "14px",boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",...props.styles}}>
        {props.children}
    </div>
  )
}

export default CustomCard
